import { render, staticRenderFns } from "./weddingbase.vue?vue&type=template&id=fc3f005c&scoped=true"
import script from "./weddingbase.vue?vue&type=script&lang=js"
export * from "./weddingbase.vue?vue&type=script&lang=js"
import style0 from "./weddingbase.vue?vue&type=style&index=0&id=fc3f005c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc3f005c",
  null
  
)

export default component.exports